import { active, pending } from "./partnerApproval";

import AddAsset from "../Components/User/Add Asset/AddAsset";
import NewBeneficiary from "../Components/User/Add Beneficiary/new_beneficiary";
import {
  generic_tips,
  tailored_tips,
} from "../Components/User/Dashboard/security_tips";
import EditAsset from "../Components/User/Edit Asset/EditAsset";
import EditBeneficiary from "../Components/User/Edit Beneficiary/edit_beneficiary";

/*
  A partner-created record awaiting approval is not part of the mechanism, so it
  cannot raise an attention point and cannot answer one either: an asset the
  partner attached to a beneficiary does not stop that beneficiary counting as
  inheriting nothing, because until the customer approves it, it inherits
  nothing.
*/
const activeAssets = (data) => active(data?.assets);
const activeBeneficiaries = (data) => active(data?.beneficiaries);

/*
  How many LIVE assets a beneficiary inherits.

  Filtering the beneficiary list is not enough on its own: a beneficiary can be
  live while everything they inherit is a partner-created draft, and reading
  visible_assets.length would then say they inherit two things when they inherit
  none. Every count of what a beneficiary gets has to go through the asset list
  as well.
*/
const inheritedCount = (data, beneficiary) => {
  /*
    Only DRAFT ids are removed -- not "ids without a live match".

    The difference matters for an id that matches no asset at all. Those exist
    in real records, and before any of this they counted towards this number.
    Excluding them here would change what existing customers see on a screen
    that has nothing to do with partners, so they are left exactly as they were.
  */
  const drafts = new Set(
    pending(data?.assets).map((a) => a?.asset_id)
  );
  return (beneficiary?.visible_assets || []).filter((id) => !drafts.has(id))
    .length;
};

/*
  How many LIVE advisors an asset has, on the same principle: a partner-created
  advisor awaiting approval is attached to nothing, so it cannot answer "this
  asset has no trusted advisor".

   is an array once decrypted, but a JSON string on records that
  predate that change, so both shapes are handled.
*/
const advisorCount = (data, asset) => {
  const drafts = new Set(pending(data?.trustees).map((t) => t?.user_id));
  let ids = asset?.trustees;
  if (typeof ids === "string") {
    try {
      ids = JSON.parse(ids);
    } catch (error) {
      ids = [];
    }
  }
  return (Array.isArray(ids) ? ids : []).filter((id) => !drafts.has(id)).length;
};


const { formatDate } = require("./formatDate");
const { formatTime } = require("./formatTime");
const maxWordLength = 40;
const type1 = (data, issuesContent) => {
  if (!activeBeneficiaries(data).some((e) => inheritedCount(data, e) > 0)) {
    return [
      {
        type: 1,
        text: issuesContent?.issue_1,
      },
    ];
  } else {
    return [];
  }
};
export const isUserActive = (data) => {
  if (activeBeneficiaries(data).some((e) => inheritedCount(data, e) > 0))
    return true;
  else return false;
};
const type2 = (data, issuesContent) => {
  var issues = [];
  activeAssets(data).map((asset) => {
    // console.log("Asset name");
    // console.log(asset.asset_name.length);
    if (asset.beneficiaries.length === 0) {
      const asset_name =
        asset.asset_name.length > maxWordLength
          ? `${asset.asset_name.slice(0, maxWordLength)}...`
          : asset.asset_name;
      issues.push({
        type: 2,
        text: issuesContent?.issue_2.replace("asset_name", asset_name),
        id: asset.asset_id,
      });
    }
    return null;
  });
  if (issues.length === 0) return [];
  else return issues;
};
const type3 = (data, issuesContent) => {
  var issues = [];
  activeBeneficiaries(data).map((beneficiary) => {
    if (inheritedCount(data, beneficiary) === 0) {
      const beneficiary_name =
        beneficiary.name.length > maxWordLength
          ? `${beneficiary.name.slice(0, maxWordLength)}...`
          : beneficiary.name;
      issues.push({
        type: 3,
        text: issuesContent?.issue_3.replace(
          "beneficiary_name",
          beneficiary_name
        ),
        id: beneficiary.user_id,
      });
    }
    return null;
  });
  if (issues.length === 0) return [];
  else return issues;
};
const type4 = (data, issuesContent) => {
  var issues = [];
  activeAssets(data).map((asset) => {
    if (advisorCount(data, asset) === 0) {
      const asset_name =
        asset.asset_name.length > maxWordLength
          ? `${asset.asset_name.slice(0, maxWordLength)}...`
          : asset.asset_name;
      issues.push({
        type: 4,
        text: issuesContent?.issue_4.replace("asste_name", asset_name),
        id: asset.asset_id,
      });
    }
    return null;
  });
  if (issues.length === 0) return [];
  else return issues;
};
const type5 = (billing, issuesContent) => {
  var issues = [];
  console.log(billing);
  // if (billing?.user_id==='undefined'||billing?.status!=="Active"||billing?.plan==='free'){
  //     console.log('Debería de entrar')
  //     issues.push({
  //             type:5,
  //             text:`Your subscription data is limited to 3 months. Ensure your love ones will inherit your assets by extending your subscription with our plans`,
  //         })
  // }
  if (billing?.plan?.toLowerCase() === "free") {
    console.log("HA ENTRADO EN EL PLAN ES FREE");
    console.log(billing?.plan);
    issues.push({
      type: 5,
      text: issuesContent?.issue_5.replace(
        "end_date",
        formatDate(billing?.nextCharge).split(" ")[0]
      ),
    });
  }
  // if (!billing) return []
  if (issues.length === 0) return [];
  else return issues;
};
const type6 = (customer, issuesContent) => {
  if (customer?.used_storage > 8.5 * 100 * 1024 * 1024) {
    return [
      {
        type: 6,
        text: issuesContent?.issue_6,
      },
    ];
  } else {
    return [];
  }
};
const type7 = (customer, issuesContent) => {
  if (!customer?.code_copied && !customer?.hided_tips.includes("7")) {
    return [
      {
        type: 7,
        text: issuesContent?.issue_7,
      },
    ];
  } else {
    return [];
  }
};
const three_months = 3 * 31 * 24 * 60 * 60 * 1000;
const type8 = (billing, issuesContent) => {
  if (billing?.cancel && billing?.nextCharge < Date.now() + three_months) {
    return [
      {
        type: 8,
        text: issuesContent?.issue_8?.replace(
          "next_charge",
          formatDate(billing?.nextCharge).split(" ")[0]
        ),
      },
    ];
  } else {
    return [];
  }
};
const type9 = (billing, issuesContent) => {
  if (
    billing?.expired_payment_method &&
    billing?.nextCharge < Date.now() + three_months
  ) {
    console.log("Ha entrado en el type9");
    console.log(issuesContent);
    return [
      {
        type: 9,
        text: issuesContent?.issue_9,
      },
    ];
  } else {
    return [];
  }
};
const hideIssue = () => {};
export const handleIssueActions = (
  userData,
  setModal,
  navigate,
  filteredIssues,
  issue,
  url,
  setIssues
) => {
  if (Number(issue.type) === 2)
    setModal(
      <EditAsset
        onClose={() => setModal(null)}
        toEdit={
          userData?.UserData?.assets?.filter((e) => e?.asset_id === issue?.id)[0]
        }
        openBeneficiary={true}
      />
    );
  if (Number(issue.type) === 3)
    setModal(
      <EditBeneficiary
        onClose={() => setModal(null)}
        toEdit={
          userData?.UserData?.beneficiaries?.filter(
            (e) => e?.user_id === issue?.id
          )[0]
        }
        openAssets={true}
      />
    );
  if (Number(issue.type) === 4)
    setModal(
      <EditAsset
        onClose={() => setModal(null)}
        toEdit={
          userData?.UserData?.assets?.filter((e) => e.asset_id === issue?.id)[0]
        }
        openBeneficiary={true}
      />
    );
  if (Number(issue.type) === 5)
    return navigate("/user/plan", { replace: true });
  if (Number(issue.type) === 7) {
    console.log(filteredIssues);
    if (url === "hide") {
      setIssues(
        filteredIssues?.filter((issue_) => Number(issue_?.type) !== issue?.type)
      );
      return userData.setCustomerUser({
        ...userData?.CustomerUser,
        hided_tips: [...userData?.CustomerUser?.hided_tips, issue.type],
      });
    }
    userData?.setMyAccount(1);
    return navigate("/user/account", {
      replace: true,
      state: { recovery_key: true },
    });
  }
  if (Number(issue.type) === 1) {
    const hasBeneficiaries = filteredIssues.some((e) => Number(e.type) === 3);
    console.log(hasBeneficiaries);
    if (url) {
      console.log("URLLL");
      console.log(url);
      return navigate(url);
    } else if (hasBeneficiaries) {
      setModal(<AddAsset onClose={() => setModal(null)} />);
    } else {
      setModal(<NewBeneficiary onClose={() => setModal(null)} />);
    }
  }
  if (Number(issue.type) === 8) {
    if (url === "hide") {
      setIssues(
        filteredIssues?.filter((issue_) => Number(issue_.type) !== issue.type)
      );
      return userData.setCustomerUser({
        ...userData?.CustomerUser,
        hided_tips: [...userData?.CustomerUser?.hided_tips, issue.type],
      });
    }
    userData?.setMyAccount(3);
    return navigate("/user/account", {
      replace: true,
      state: { subscriptionRenewal: true },
    });
  }
  if (Number(issue.type) === 9) {
    if (url === "hide") {
      setIssues(
        filteredIssues?.filter((issue_) => Number(issue_.type) !== issue.type)
      );
      return userData.setCustomerUser({
        ...userData?.CustomerUser,
        hided_tips: [...userData?.CustomerUser?.hided_tips, issue.type],
      });
    }
    userData?.setMyAccount(3);
    return navigate("/user/account", {
      replace: true,
      state: { updatePayment: true },
    });
  }
};
export const handleIssues = (data, billing, customer, issuesContent) => {
  console.log(issuesContent);
  const type1_issues = type1(data, issuesContent);
  const type2_issues = type2(data, issuesContent);
  const type3_issues = type3(data, issuesContent);
  const type4_issues = type4(data, issuesContent);
  const type5_issues = type5(billing, issuesContent);
  const type6_issues = type6(customer, issuesContent);
  const type7_issues = type7(customer, issuesContent);
  const type8_issues = type8(billing, issuesContent);
  const type9_issues = type9(billing, issuesContent);
  const issues = [
    type1_issues,
    type2_issues,
    type3_issues,
    type4_issues,
    type5_issues,
    type6_issues,
    type7_issues,
    type8_issues,
    type9_issues,
  ];

  return issues;
};

/*
  Attention points for a partner looking at a customer.

  Types 1 to 4 only, and that is the whole of it. Those four are about the
  inheritance mechanism -- an asset with no beneficiary, a beneficiary
  inheriting nothing -- which is the work a partner is there to do. Five
  through nine are the customer's subscription, their storage and a nudge about
  their recovery key: Ostreon's business with them, not the partner's.

  The four that remain still name things. issue_2 and issue_4 splice in an asset
  name and issue_3 a beneficiary name, so this is safe only because  here
  is the shared payload -- it holds nothing the customer did not share, so
  nothing unshared can be named. Never call this with a full record.
*/
/*
  The partner's view of a customer's dashboard.

  Only about records the PARTNER created and the customer has not approved --
  never about the customer's own. Two reasons, and either alone decides it.

  The partner sees a partial account. An asset can be shared while its
  beneficiaries are not, so "this asset is not associated with any active
  beneficiary" is a sentence the data cannot support: it was being said about
  associations that already existed and that the partner simply could not see.

  And an attention point is a call to act. The only thing a partner can act on
  is a draft of their own -- the customer's records are not theirs to change
  -- so a point about one is an instruction to do something impossible.

  What is left is worth saying: they have just added an asset and may have
  forgotten to put anybody on it. Their own drafts, checked against their own
  drafts, where nothing is hidden from them.

  No type1 here. "Nobody inherits anything" is a statement about the whole
  estate, and a partial account cannot make it.
*/
const shorten = (name) => {
  const text = String(name || "");
  return text.length > maxWordLength
    ? `${text.slice(0, maxWordLength)}...`
    : text;
};

/*
  An asset's advisor ids. Same two shapes advisorCount handles -- an array
  once decrypted, a JSON string on records that predate that change -- but
  counted WITHOUT dropping drafts: in this view the drafts are the subject,
  and an advisor the partner added in the same breath is a real association.
*/
const idList = (value) => {
  let ids = value;
  if (typeof ids === "string") {
    try {
      ids = JSON.parse(ids);
    } catch (error) {
      ids = [];
    }
  }
  return Array.isArray(ids) ? ids : [];
};

export const handleSharedIssues = (data, issuesContent) => {
  const issues = [];

  pending(data?.assets).forEach((asset) => {
    const asset_name = shorten(asset?.asset_name);
    if (idList(asset?.beneficiaries).length === 0) {
      issues.push({
        type: 2,
        text: issuesContent?.issue_2?.replace("asset_name", asset_name),
        id: asset?.asset_id,
      });
    }
    if (idList(asset?.trustees).length === 0) {
      issues.push({
        type: 4,
        text: issuesContent?.issue_4?.replace("asset_name", asset_name),
        id: asset?.asset_id,
      });
    }
  });

  pending(data?.beneficiaries).forEach((beneficiary) => {
    if (idList(beneficiary?.visible_assets).length === 0) {
      issues.push({
        type: 3,
        text: issuesContent?.issue_3?.replace(
          "beneficiary_name",
          shorten(beneficiary?.name)
        ),
        id: beneficiary?.user_id,
      });
    }
  });

  // The caller flattens one level; see Dashboard.jsx.
  return [issues];
};

export const handleTips = (customer, userdata) => {
  let tips = [];
  if (userdata?.legal?.length === 0) tips.push("tailored_1");
  if (!customer?.self_recovery_id_private_key) tips.push("tailored_2");
  if (!customer?.mfa?.toLowerCase() === "email") tips.push("tailored_3");
  tips = [...tips, ...generic_tips.map((e) => e?.id)];
  const full_tips = [
    ...generic_tips,
    ...tailored_tips.filter((e) => tips.includes(e?.id)),
  ];
  console.log("handleTips");

  return (
    full_tips
      .filter((e) => !customer?.hided_tips.includes(e?.id))
      .sort(() => Math.random() - 0.5) || []
  );
};
